<template>
  <div>
    <div class="text-xs">店铺管理</div>
    <div class="flex text-xxs flex-wrap">
      <div
        class="flex flex-col text-xxs justify-between items-center w-1/5 my-1"
        @click="$router.push({ name: 'StoreTeam' })"
      >
        <img
          height="36px"
          width="36px"
          src="@/assets/store/我的团队.svg"
          alt=""
        />我的团队
      </div>
      <!-- <div
        class="flex flex-col text-xxs justify-between items-center w-1/5 my-1"
        @click="$router.push({ name: 'StoreCustomer' })"
      >
        <img
          height="36px"
          width="36px"
          src="@/assets/store/我的顾客.svg"
          alt=""
        />我的顾客
      </div> -->
      <div
        class="flex flex-col text-xxs justify-between items-center w-1/5 my-1"
        @click="$router.push({ name: 'StoreSellData' })"
      >
        <img
          height="36px"
          width="36px"
          src="@/assets/store/店铺业绩.svg"
          alt=""
        />店铺业绩
      </div>
      <div
        class="flex flex-col text-xxs justify-between items-center w-1/5 my-1"
        @click="expandShop(1)"
      >
        <img
          height="36px"
          width="36px"
          src="@/assets/store/拓展店长.svg"
          alt=""
        />拓展店长
      </div>
      <div
        class="flex flex-col text-xxs justify-between items-center w-1/5 my-1"
        @click="expandShop(2)"
      >
        <img
          height="36px"
          width="36px"
          src="@/assets/store/分享店铺.svg"
          alt=""
        />分享店铺
      </div>
      <div
        class="flex flex-col text-xxs justify-between items-center w-1/5 my-1"
        @click="$router.push({ name: 'StoreRedpack' })"
      >
        <img
          height="36px"
          width="36px"
          src="@/assets/store/店主发红包.svg"
          alt=""
        />店主发红包
      </div>
      <div
        class="flex flex-col text-xxs justify-between items-center w-1/5 my-1"
        @click="$router.push({ name: 'StoreVisitor' })"
      >
        <img
          height="36px"
          width="36px"
          src="@/assets/store/我的访客.svg"
          alt=""
        />我的访客
      </div>
      <div
        class="flex flex-col text-xxs justify-between items-center w-1/5 my-1"
        @click="$router.push({ name: 'StoreCustomerRank' })"
      >
        <img
          height="36px"
          width="36px"
          src="@/assets/store/顾客贡献榜.svg"
          alt=""
        />顾客贡献榜
      </div>
      <Overlay
        :show="showShare"
        v-if="browserType !== 'weixin'"
        @click="showShare = false"
        style="z-index: 2"
      >
      </Overlay>
    </div>
  </div>
</template>

<script>
import { Image as VImage, Toast, Overlay } from "vant";
import { priceMarkup } from "@/api/forward.js";
export default {
  components: { Overlay },
  data() {
    return {
      urlAddress: null,
      expandType: 1,
      showShare: false,
      browserType: localStorage.getItem("browserType"),
    };
  },
  methods: {
    expandShop(i) {
      this.$store.dispatch("app/showLoading");
      let urlAddress;

      if (i === 1) {
        urlAddress =
          location.origin +
          "/mine/setting/settingInviteCode?customerId=" +
          this.$store.state.user.forwardId;
        priceMarkup({
          forwardType: "SHOPKEEPER",
          urlAddress,
        })
          .then(({ data }) => {
            this.$store.dispatch("app/hideLoading");
            this.expandType = i;

            this.invitationCode = data.invitationCode;

            // this.showShare = true;
            this.diagVisible = false;
            this.$store.dispatch("sharePoster/show", {
              url: data.url,
              title: this.$store.state.user.userInfoNickname,
              desc: "",
              link: urlAddress,
              imgUrl: this.$store.state.user.userInfoAvatar,
              moreOption: [
                {
                  text: "邀新码复制",
                  img: require("@/assets/store/邀新码复制.svg"),
                  invitationCode: data.invitationCode,
                },
              ],
              hideOption: ["朋友圈"],
            });
          })
          .catch(() => {
            this.$store.dispatch("app/hideLoading");
          });
      } else if (i === 2) {
        if (location.hostname === "localhost") {
          urlAddress =
            window.location.origin +
            location.pathname +
            "?customerId=" +
            this.$store.state.user.forwardId;
        } else {
          urlAddress =
            location.href + "?customerId=" + this.$store.state.user.forwardId;
        }
        priceMarkup({ forwardType: "STORE", urlAddress })
          .then(({ data }) => {
            this.$store.dispatch("app/hideLoading");
            this.expandType = i;

            // this.showShare = true;
            this.diagVisible = false;
            this.$store.dispatch("sharePoster/show", {
              url: data.url,
              title: this.$store.state.user.userInfoNickname,
              desc: "",
              link: urlAddress,
              imgUrl: this.$store.state.user.userInfoAvatar,
            });
          })
          .catch(() => {
            this.$store.dispatch("app/hideLoading");
          });
      }
      this.urlAddress = urlAddress;
      console.log(1);
    },
  },
};
</script>

<style scoped>
::v-deep .van-share-sheet__name {
  font-size: 20px;
}
</style>